import Page from '../../../../../components/pages/TablePage';
import React from 'react';

export default () =>{
    return (
        <Page 
            title={'flight_master'}
        />
    )
}